import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import {
	CommonSwitch,
	CustomDropdown,
	CustomTextInput,
	UserInfoTextInput,
} from "../../common-components/inputs";
import { Card, Divider } from "@mui/material";
import { NeutralColor, SecondaryColor } from "node-library/dist/colors";
import {
	CompanyIcon,
	DeleteIcon,
	EmailIcon,
	InvoiceIcon,
	LockIcon,
	UserIcon,
	WorldIcon,
} from "../../common-components/svgIcons";
import { useSnackbar } from "../../common-components/toast/showToastMessage";
import { FrontendProfileTab, Severity } from "node-library/dist/constants";
import { YellowWarnIcon } from "../../common-components/toast/warnIcons";
import {
	GreenButton,
	OutlinedButton,
	TextButton,
} from "../../common-components/button";

interface Props {
	// States for user info
	clientInformationFields: Array<any>;

	// enableNotificationEmail: boolean;
	// setEnableNotificationEmail: React.Dispatch<React.SetStateAction<boolean>>;

	// States for password modal
	setChangePasswordModalOpen: React.Dispatch<React.SetStateAction<boolean>>;

	// Props for unsaved changes state
	setUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function UserClientInfoSection(props: Props) {
	const { t: translation } = useTranslation();

	const { openSnackbar } = useSnackbar();

	const {
		clientInformationFields,

		// enableNotificationEmail,
		// setEnableNotificationEmail,

		setChangePasswordModalOpen,
		setUnsavedChanges,
	} = props;

	const clientInformation: React.ReactNode = (
		<div>
			<div className="profile-information-container">
				<div className="profile-icon-header-row typography-heading-03">
					<UserIcon
						strokeColor={NeutralColor.NEUTRAL_GREY_950}
						fillColor={NeutralColor.NEUTRAL_GREY_950}
					></UserIcon>
					{translation("ClientInformation")}
				</div>
				<div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("ClientInformationDescription")}
				</div>
				<div className="profile-client-info-input-row">
					{clientInformationFields.map((field) => {
						return (
							<CustomTextInput
								id={field.id}
								key={field.id}
								value={field.value}
								setValue={(value) => {
									field.setValue(value);
									setUnsavedChanges(true);
								}}
								label={field.label}
								disabled={field.disabled}
								type={field.type}
								required={field.required}
								errorMsg={field.errorMsg}
								setErrorMsg={field.setErrorMsg}
							></CustomTextInput>
						);
					})}
				</div>
			</div>
			<Divider orientation="horizontal" flexItem sx={{ my: 2 }}></Divider>

			{/* <div className="common-card-header profile-card-header-wrap profile-information-container">
				<div>
					<div className="profile-icon-header-row typography-heading-03">
						<EmailIcon
							size={24}
							strokeColor="white"
							fillColor={NeutralColor.NEUTRAL_GREY_950}
						></EmailIcon>
						{translation("OrderStatusUpdateNotifications")}
					</div>
					<div
						className="typography-caption"
						style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
					>
						{translation("OrderStatusUpdateNotificationsDescription")}
					</div>
				</div>
				<CommonSwitch
					id={"enable-email-notification-switch"}
					checked={enableNotificationEmail}
					setChecked={setEnableNotificationEmail}
				/>
			</div>
			<Divider orientation="horizontal" flexItem sx={{ my: 2 }}></Divider> */}

			<div className="profile-password-header">
				<div className="profile-icon-header-row typography-heading-03">
					<LockIcon
						strokeColor={NeutralColor.NEUTRAL_GREY_950}
						fillColor={NeutralColor.NEUTRAL_GREY_950}
					></LockIcon>
					{translation("Password")}
				</div>
				<OutlinedButton
					id="change-password-button"
					size="medium"
					children={translation("ChangePassword")}
					//onClick={() => setCurrentPageIndex(1)}
					onClick={() => {
						setChangePasswordModalOpen(true);
					}}
					outlineColor={NeutralColor.NEUTRAL_GREY_950}
				></OutlinedButton>
			</div>
		</div>
	);

	return clientInformation;
}
